import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  handleStepCurrent,
  fetchCertificates,
} from "../../../features/profile/profileSlice";
import { Spin } from "antd";
import dayjs from "dayjs";

export default function CertificateTab({ profileApplication, editProfile }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { certificates = [], profileLoading } = useSelector(
    (state) => state.profile
  );

  useEffect(() => {
    dispatch(fetchCertificates());
  }, [dispatch]);

  async function handleProfileBuilder() {
    await dispatch(handleStepCurrent(4));
    await navigate("/profile-builder");
  }

  return (
    <>
      <div className="flex justify-end">
        {profileApplication || editProfile ? null : (
          <button
            onClick={handleProfileBuilder}
            className="bg-transparent flex items-center border-none my-5"
          >
            <div className="bg-darkBlue rounded-full p-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4 16C4 15.4477 4.44772 15 5 15H27C27.5523 15 28 15.4477 28 16C28 16.5523 27.5523 17 27 17H5C4.44772 17 4 16.5523 4 16Z"
                  fill="white"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16 4C16.5523 4 17 4.44772 17 5V27C17 27.5523 16.5523 28 16 28C15.4477 28 15 27.5523 15 27V5C15 4.44772 15.4477 4 16 4Z"
                  fill="white"
                />
              </svg>
            </div>
            <span className="text-darkBlue font-medium text-[17px] ml-3">
              Add Certificate
            </span>
          </button>
        )}
      </div>

      {profileLoading && !certificates.length && <Spin size="large" />}

      {certificates.length > 0
        ? certificates.map((item) => (
            <div key={item.id}>
              <div className="bg-white p-6 mb-4 flex items-center justify-between w-full">
                <div className="w-full flex flex-col">
                  <div className="flex items-center justify-between">
                    <h3 className="text-darkBlue text-[21px] font-bold">
                      {item.certificateName}
                    </h3>
                    <span className="bg-blue-100 text-darkBlue text-[13px] font-medium px-3 py-1 rounded-full">
                      {item.category}
                    </span>
                  </div>
                  <p className="text-black333 font-medium text-[18px] my-1">
                    {item.institution}
                  </p>
                  {item.certificateNumber && (
                    <span className="text-black333 font-normal text-[16px]">
                      Certificate No: {item.certificateNumber}
                    </span>
                  )}
                  {item.profession && (
                    <span className="text-black333 font-normal text-[16px]">
                      Profession: {item.profession}
                    </span>
                  )}
                  {item.endDate && (
                    <span className="text-black333 font-normal text-[19px] mt-1">
                      {dayjs(item.endDate).format("MMMM YYYY")}
                    </span>
                  )}
                  {item.certificatePath && (
                    <div className="mt-3">
                      {item.certificatePath.match(/\.(jpg|jpeg|png|gif|webp)$/i) ? (
                        <a
                          href={`${process.env.REACT_APP_API_BASE_URL}${item.certificatePath}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={`${process.env.REACT_APP_API_BASE_URL}${item.certificatePath}`}
                            alt={item.certificateName}
                            className="w-32 h-32 object-cover rounded-lg border"
                          />
                        </a>
                      ) : (
                        <a
                          href={`${process.env.REACT_APP_API_BASE_URL}${item.certificatePath}`}
                          target="_blank"
                          rel="noreferrer"
                          className="text-darkBlue underline text-sm"
                        >
                          View Certificate
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div
                style={{
                  background: "#D8D8D88A",
                  height: "1px",
                  width: "100%",
                }}
                className="my-10"
              ></div>
            </div>
          ))
        : !profileLoading && (
            <div className="flex items-center justify-center w-full h-full py-10">
              <p className="text-gray-400">No certificates added yet</p>
            </div>
          )}
    </>
  );
}
